import React, { useEffect, useState } from "react";
import "../styles/QuizComponentStyle.css";
import QuizImg from "../../../../assets/images/popQuiz/popQuizImg.png";
import QuizScoreComponent from "./QuizScoreComponent";
import PopQuizUnAnsweredSnackBar from "../../../../components/popQuizUnAnsweredSnackBar";
import PopQuizSuccessSnackBar from "../../../../components/popQuizSuccuessSnackBar";
import QuizPopUp from "../../../../components/QuizPopUp";
import {
  createQuizRequest,
  QuizData,
  quizData,
  ResponseOption,
} from "../data/response/popQuizResponse";
import PopQuizApiCall from "../data/api_services/PopquizApicall";
import { setNextVideo, setNoOfQuestions } from "../data/redux/popQuizRedux";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../../store/store";
import {
  setQuizComponentActive,
  setQuizOverlayActive,
} from "../data/redux/QuizLogoutRedux";
import logoutUser from "../../../../features/sideBar/data/api_services/LogoutApi";
import QuizPopUpLogout from "../../../../components/QuizPopUpLogout";
import { useApi } from "../../../../service/ApiContext";
import { useNavigate } from "react-router-dom";
import Logger from "../../../../utils/Logger";
import { useCamera } from "../../../assessment/components/CameraContext";
const questionsData = [
  {
    question:
      "What does a sensor do in a robot?What does a sensor do in a robot?What does a sensor do in a robot?What does a sensor do in a robot?What does a sensor do in a robot?What does a sensor do in a robot?What does a sensor do in a robot?What does a sensor do in a robot?What does a sensor do in a robot?What does a sensor do in a robot?What does a sensor do in a robot?What does a sensor do in a robot?What does a sensor do in a robot?What does a sensor do in a robot?What does a sensor do in a robot?What does a sensor do in a robot?What does a sensor do in a robot?What does a sensor do in a robot?What does a sensor do in a robot?What does a sensor do in a robot?What does a sensor do in a robot?What does a sensor do in a robot?What does a sensor do in a robot?What does a sensor do in a robot?What does a sensor do in a robot?What does a sensor do in a robot?What does a sensor do in a robot?What does a sensor do in a robot?What does a sensor do in a robot?What does a sensor do in a robot?What does a sensor do in a robot?What does a sensor do in a robot?What does a sensor do in a robot?What does a sensor do in a robot?What does a sensor do in a robot?What does a sensor do in a robot?What does a sensor do in a robot?What does a sensor do in a robot?What does a sensor do in a robot?What does a sensor do in a robot?What does a sensor do in a robot?What does a sensor do in a robot?What does a sensor do in a robot?What does a sensor do in a robot?What does a sensor do in a robot?What does a sensor do in a robot?What does a sensor do in a robot?What does a sensor do in a robot?What does a sensor do in a robot?",
    options: [
      "Decorates the robot",
      "Helps it move",
      "Collects information from the surroundings information from the surroundings information from the surroundings information from the surroundings information from the surroundings information from the surroundings ",
      "Charges the battery",
    ],
    correctAnswer: "Collects information from the surroundings",
  },
  {
    question: "What is the brain of the robot called?",
    options: ["Heart", "Motor", "Sensor", "Controller"],
    correctAnswer: "Controller",
  },
  {
    question: "Which part helps a robot to move?",
    options: ["Legs", "Wheels", "Arms", "Eyes"],
    correctAnswer: "Wheels",
  },
  {
    question: "What energy source do most robots use?",
    options: ["Solar", "Electric", "Water", "Wind"],
    correctAnswer: "Electric",
  },
  {
    question: "Which sense does a sensor replace in robots?",
    options: ["Touch", "Smell", "Taste", "Thinking"],
    correctAnswer: "Touch",
  },
];

export interface QuizComponentProps {
  setShowQuizComponent: (show: boolean) => void;
  quizData: QuizData;
  video_id: String;
  assessment_id: String;
  is_graded?: boolean;
  showAlertForIsGraded?: boolean;
  btnPressTriggers?: () => void;
  handleSubmitTriggers?: () => void;
}

const QuizComponent: React.FC<QuizComponentProps> = ({
  setShowQuizComponent,
  quizData,
  video_id,
  assessment_id,
  is_graded,
  showAlertForIsGraded,
  btnPressTriggers,
  handleSubmitTriggers,
}) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [showScore, setShowScore] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
  const [showNotAnsMsg, setShowNotAnsMsg] = useState(false);
  const [showAlert, setShowAlert] = useState(false);
  const { submitQuizData } = PopQuizApiCall();
  const [answers, setAnswers] = useState(
    Array(quizData.questions.length).fill(null),
  );
  const [submissionResponse, setSubmissionResponse] = useState<any>(null); // Adjust type as needed
  const dispatch = useDispatch();
  const api = useApi();
  const navigate = useNavigate();
  const { stopCamera, isCameraEnabled } = useCamera();

  const closeAssessmentCamera = () => {
    stopCamera();
    window.location.reload();
  };
  const handleOptionSelect = (option: ResponseOption) => {
    const updatedAnswers = [...answers];
    updatedAnswers[currentIndex] = option.answer_id; // Store answer_id instead of answer text
    setAnswers(updatedAnswers);
  };

  const isAnswered = answers[currentIndex] !== null;
  const userData = useSelector((state: RootState) => state.profile.profileKeys);
  const quizComponentActive = useSelector(
    (state: RootState) => state.QuizLogout.quizComponentActive,
  );
  const handleSaveAndNext = async () => {
    const updatedAnswers = [...answers];

    // Prevent moving forward if the current question is unanswered
    if (!updatedAnswers[currentIndex]) {
      setShowNotAnsMsg(true);
      setTimeout(() => setShowNotAnsMsg(false), 3000);
      return;
    }

    const allAnswered = updatedAnswers.every((ans) => ans !== null);

    // If not last question, go to next unanswered one
    const nextUnanswered = updatedAnswers.findIndex(
      (ans, index) => ans === null && index > currentIndex,
    );
    if (nextUnanswered !== -1) {
      setCurrentIndex(nextUnanswered);
    } else if (!allAnswered) {
      const firstUnanswered = updatedAnswers.findIndex((ans) => ans === null);
      if (firstUnanswered !== -1) setCurrentIndex(firstUnanswered);
    } else {
      // All answered — take to last question
      setCurrentIndex(quizData.questions.length - 1);
    }
    const payload = createQuizRequest(quizData.questions, updatedAnswers);

    // Case: Last question and not all answered — show warning
    if (currentIndex === quizData.questions.length - 1 && !allAnswered) {
      setShowNotAnsMsg(true);
      setTimeout(() => setShowNotAnsMsg(false), 3000);
      return;
    }

    // Case: Last question and all answered — show success
    if (currentIndex === quizData.questions.length - 1 && allAnswered) {
      const payload = createQuizRequest(quizData.questions, updatedAnswers);
      Logger.info(
        "PayloadSuccess for submission:",
        JSON.stringify(payload, null, 2),
      );

      const response = await submitQuizData(assessment_id, video_id, payload); // Send the payload here
      if (response) {
        handleSubmitTriggers && handleSubmitTriggers();
        setShowSuccess(true);
        setTimeout(() => setShowSuccess(false), 3000);
        setTimeout(() => setShowScore(true), 2000);
        Logger.info("Quiz submission successful:", response.no_of_questions);
        setSubmissionResponse(response);
      } else {
        Logger.info("Quiz submission failed");
      }
      return;
    }
    // Use the createQuizRequest function to generate the payload

    // Log the payload to the console
    Logger.info("Payload for submission:", JSON.stringify(payload, null, 2));

    // Now, you can make your API call to submit the payload if the API URL is available
    // Example API call:
    // e.g., await api.submitQuiz(payload);
  };

  if (
    !quizData ||
    !Array.isArray(quizData.questions) ||
    quizData.questions.length === 0
  ) {
    return (
      <div className="popquiz-container">
        <p>Quiz data is not available or empty.</p>
      </div>
    );
  }

  return (
    <div className="popquiz-container">
      {quizComponentActive && (
        <QuizPopUpLogout
          title={"Logout"}
          body={"Are you sure you want to logout?"}
          btn1onPressed={() => {
            Logger.info("ok clicked");
            if (document.fullscreenElement) {
              document.exitFullscreen();
            }
            dispatch(setQuizComponentActive(false));
            dispatch(setQuizOverlayActive(false));
            logoutUser(
              dispatch,
              navigate,
              userData.candidate_id || "",
              api,
              closeAssessmentCamera,
            );
          }}
          btn2onPressed={() => {
            dispatch(setQuizComponentActive(false));
            // setShowQuizComponent(true);
          }}
        ></QuizPopUpLogout>
      )}
      {showAlertForIsGraded && (
        <QuizPopUpLogout
          title={"Warning"}
          body={
            "Completing the pop-quiz is mandatory. Please complete the pop-quiz before proceeding"
          }
          btn1onPressed={() => {
            // // Optionally focus on the quiz button
            // setShowAlertforIsGraded(false);
            // setShowMarkAsCompleted(true);
            btnPressTriggers && btnPressTriggers();
          }}
          btn2onPressed={() => {
            btnPressTriggers && btnPressTriggers();
          }}
        ></QuizPopUpLogout>
      )}

      <div
        className="popquiz-header"
        style={{ display: "flex", justifyContent: "space-between" }}
      >
        <img src={QuizImg} alt="quiz" className="popQuizImg" />
        {is_graded !== true && (
          <button
            className="skip-popquiz"
            onClick={() => {
              setShowAlert(true);
            }}
          >
            Skip Quiz
          </button>
        )}
      </div>

      <br></br>
      <div className="popQuiz-scrollContainer">
        <div
          className="quiz-body"
          style={{
            display: "flex",
            justifyContent: "space-between",
            // height: "80%",
          }}
        >
          <div
            style={{
              width: "50%",
              minHeight: "300px",
              overflowY: "auto",
              display: "flex",
              justifyContent: "start", // centers horizontally
              alignItems: "start",
            }}
          >
            <div className="popQuizquestion-box" style={{ fontSize: "14px" }}>
              
              <p
                style={{
                  fontSize: "16px",
                  paddingTop: "0px",
                  width: "100%",
                  textAlign: "left",
                }}
              >
                {quizData?.questions[currentIndex]?.question.question}
              </p>
            </div>
          </div>
          <div
            style={{
              width: "1px",
              height: "100%",
              border: "2px solid #145789",
              marginRight: "15px",
            }}
          ></div>
          <div
            style={{
              width: "50%",
              minHeight: "300px",

              overflowY: "auto",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            {[
              quizData.questions[currentIndex].question.response_option_1,
              quizData.questions[currentIndex].question.response_option_2,
              quizData.questions[currentIndex].question.response_option_3,
              quizData.questions[currentIndex].question.response_option_4,
            ]
              .filter((option): option is ResponseOption => option !== null) // 💥 filter out nulls properly
              .map((option, i) => (
                <button
                  key={i}
                  onClick={() => handleOptionSelect(option)}
                  className={`option-button ${
                    answers[currentIndex] === option.answer_id ? "selected" : ""
                  }`}
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    marginBottom: i === 3 ? "0" : "10px",
                    background:
                      answers[currentIndex] === option.answer_id
                        ? "#FFA800"
                        : "#fff",
                    padding: "10px",
                    paddingRight: "0px",
                    borderRadius: "8px",
                    width: "100%",
                    maxWidth: "100%",
                    wordBreak: "break-word",
                    justifyContent: "flex-start",
                    textAlign: "left",
                  }}
                >
                  <span
                    style={{
                      width: "30px",
                      height: "30px",
                      borderRadius: "8px",
                      backgroundColor:
                        answers[currentIndex] === option.answer_id
                          ? "#fff"
                          : "#C8C8C8",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      fontWeight: "bold",
                      color:
                        answers[currentIndex] === option.answer_id
                          ? "#1A1F24"
                          : "#fff",
                      marginRight: "10px",
                    }}
                  >
                    {String.fromCharCode(65 + i)}
                  </span>

                  <div
                    style={{
                      width: "calc(100% - 40px)",
                      overflowY: "auto",
                      maxHeight: "100px",
                    }}
                  >
                    {option.answer}
                  </div>
                </button>
              ))}
          </div>
        </div>
        <br></br>

        <div className="quiz-footer" style={{ marginTop: 0 }}>
          <div className="question-nav" style={{}}>
            {quizData.questions.map((_, i) => (
              <span
                key={i}
                onClick={() => setCurrentIndex(i)}
                className={`question-num ${
                  currentIndex === i ? "current" : ""
                } ${answers[i] ? "answered" : "unanswered"}`}
                style={{
                  cursor: "pointer",
                  fontSize: currentIndex === i ? "22px" : "18px",
                  fontWeight: currentIndex === i ? "700" : "400",
                  color: "white",
                  borderBottom:
                    currentIndex === i
                      ? "none"
                      : answers[i]
                        ? "4px solid #FFA800"
                        : "4px solid #429EE0",
                }}
              >
                {String(i + 1).padStart(2, "0")}
              </span>
            ))}
          </div>

          <button
            onClick={handleSaveAndNext}
            style={{
              padding: "8px 16px",
              borderRadius: 8,
              border: "none",
              color: "#2D2D2D",
              fontSize: "18px",
              fontWeight: 600,
              backgroundColor: isAnswered ? "#FFC858" : "#ECEFF3",
              cursor: isAnswered ? "pointer" : "not-allowed", // Disable pointer if not answered
            }}
            disabled={!isAnswered}
          >
            {currentIndex < quizData.questions.length - 1
              ? "Save & Next"
              : "Submit"}
          </button>
          {showScore && <QuizScoreComponent response={submissionResponse} />}
        </div>
      </div>
      {showSuccess && (
        <PopQuizSuccessSnackBar message="Quiz responses submitted successfully" />
      )}
      {showNotAnsMsg && (
        <PopQuizUnAnsweredSnackBar message="Please respond to all the questions before submitting the quiz" />
      )}
      {showAlert && (
        <QuizPopUpLogout
          title={"Confirmation"}
          body={"Are you sure you want to skip the quiz?"}
          btn1onPressed={() => {
            if (document.fullscreenElement) {
              document.exitFullscreen();
            }
            dispatch(setNextVideo(true));

            setShowQuizComponent(false); // hide the quiz
          }}
          btn2onPressed={() => {
            setShowAlert(false);
          }}
        ></ QuizPopUpLogout>
      )}
    </div>
  );
};
export default QuizComponent;
